class searchDrawerTrigger extends HTMLElement {
constructor() {
    super();
    this.initialized = false;
}

connectedCallback() {
    if (this.initialized) return;
    
    this.searchDrawer = document.querySelector('#search-drawer-model');

    if (!this.searchDrawer) return;
    
    this.initialized = true;
    this.focusElement = null;
    this.addEventListener("click", this.openDrawer.bind(this));
    this.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        this.openDrawer(event);
      }
    });
  }

  openDrawer(event) {
    this.searchDrawer.classList.add("is-visible");
    document.body.classList.add("overflow-hidden");

    // Input'a focus yap - trapFocusElements'i geç
    const tryFocus = () => {
      const input = this.searchDrawer.querySelector('input[type="search"], input[type="text"]');
      if (input) {
        // Önce input'a focus yap
        input.focus();
        input.select?.();
        
        // trapFocusElements'i çağır ama input'a focus'u koru
        setTimeout(() => {
          this.focusElement = event.target;
          if (this.searchDrawer && typeof trapFocusElements === "function") {
            // trapFocusElements çağrılmadan önce input'a focus yap
            input.focus();
            trapFocusElements(this.searchDrawer);
            
            // trapFocusElements çağrıldıktan hemen sonra tekrar input'a focus yap
            requestAnimationFrame(() => {
              setTimeout(() => {
                if (input) {
                  input.focus();
                }
              }, 10);
            });
          }
        }, 200);
      } else {
        // Retry after a bit, if input isn't ready yet
        setTimeout(tryFocus, 50);
      }
    };

    // Try to focus after rendering
    requestAnimationFrame(() => {
      setTimeout(tryFocus, 200); // Drawer animasyonu için biraz daha bekle
    });
  }

}

customElements.define("search-drawer", searchDrawerTrigger);

class searchModalDialog extends HTMLElement{
      constructor() {
        super();
        this.closeBtns = this.querySelectorAll('[data-drawer-close]');
        this.suggestionsContent = this.querySelector('[data-suggestion-content]');
        this.resultsContainer = this.querySelector('[data-predictive-search-body]');
        this.loadingContainer = this.querySelector('[data-loading-content]');
        this.resultsWrapper = this.querySelector('[data-results-wrapper]');
        this.drawerBase = this.querySelector('.drawer-base');
        this.clear = this.querySelector('[data-clear-input]');
        this.voiceSearchBtn = this.querySelector('[data-voice-search]');
        this.isFirstSearch = true; // İlk arama kontrolü için flag
        
        // Section ayarlarını oku
        this.productLimit = parseInt(this.dataset.productLimit || '14', 10);
        this.hasShownDefaultCollection = false; // Default koleksiyon gösterildi mi?
        this.defaultCollectionWrapper = this.querySelector('[data-default-collection-wrapper]');
        this.defaultCollectionResults = this.querySelector('[data-default-collection-results]');
        this.noResultsDivider = this.querySelector('[data-no-results-divider]');

        // Collection tabs yönetimi
        this.collectionTabsWrapper = this.querySelector('[data-collection-tabs-wrapper]');
        this.collectionTabs = this.querySelectorAll('[data-collection-tab]');
        this.collectionProducts = this.querySelectorAll('[data-collection-products]');
        this.initCollectionTabs();
        this.initSearchViewAllButtons();
        if(this.closeBtn){
          this.closeBtn.addEventListener("click",this.closeDrawer.bind(this))
        }
        Array.from(this.closeBtns).forEach(function(closeBtn){
          closeBtn.addEventListener("click",function(event){
            event.preventDefault();
            this.closeDrawer();
          }.bind(this))
        }.bind(this))
        this.input = this.querySelector('input[type="search"]');

        if (this.input) {
          this.input.addEventListener(
            'input',
            this.debounce((event) => {
              this.onChange(event);
            }, 300).bind(this)
          );
          if (this.clear) {
          this.clear.addEventListener(
            'click',function(){
             this.input.value = ''; 
              this.input.dispatchEvent(new Event("input", { bubbles: true }));
               // Wait for the drawer to actually render and be focusable
              const tryFocus = () => {
                const input = this.input;
                if (input) {
                  input.focus();
                  // Optional: select the input content
                  input.select?.();
                } else {
                  // Retry after a bit, if input isn't ready yet
                  setTimeout(tryFocus, 50);
                }
              };
          
              // Try to focus after rendering
              requestAnimationFrame(() => {
                setTimeout(tryFocus, 100); // Adjust if you have transition delays
              });
            }.bind(this));
        }
        if (this.voiceSearchBtn) {
          this.voiceSearchBtn.addEventListener('click', this.toggleVoiceSearch.bind(this));
        }
        }
        document.addEventListener('keydown', this.handleKeyDown.bind(this));
        
        // Drawer açıldığında input'a focus yap ve default koleksiyonu göster
        this.observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              if (this.classList.contains('is-visible')) {
                this.focusInput();
                // Eğer input boşsa ve default koleksiyon varsa göster
                if (!this.hasShownDefaultCollection && this.defaultCollectionWrapper && (!this.input || !this.input.value.trim())) {
                  this.showDefaultCollection();
                }
              }
            }
          });
        });
        this.observer.observe(this, { attributes: true });
      }
    
      focusInput() {
        if (this.input) {
          // Kısa bir gecikme ile focus yap (drawer animasyonu tamamlansın)
          setTimeout(() => {
            if (this.input) {
              this.input.focus();
              // trapFocusElements çağrıldıysa tekrar input'a focus yap
              setTimeout(() => {
                if (this.input) {
                  this.input.focus();
                  // Bir kez daha kontrol et
                  requestAnimationFrame(() => {
                    if (this.input) {
                      this.input.focus();
                    }
                  });
                }
              }, 150);
            }
          }, 200);
        }
      }
    
      closeDrawer(){
        this.classList.remove("is-visible");
        document.querySelector("body").classList.remove("overflow-hidden");
        const searchItem = document.querySelector("search-drawer")
        if(searchItem){
           searchItem.focus()
        }
        removeTrapFocus();
      }
  
       handleKeyDown(event) {
        if (event.key === 'Escape') {
          this.closeDrawer(event); // Call closeDrawer when Escape is pressed
        }
      }

      toggleVoiceSearch() {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
          console.warn('Sesli arama bu tarayıcıda desteklenmiyor.');
          return;
        }
        if (this._voiceSearchActive) {
          this._recognition?.stop();
          this._voiceSearchActive = false;
          this.voiceSearchBtn?.classList.remove('is-recording');
          return;
        }
        if (!this._recognition) {
          this._recognition = new SpeechRecognition();
          this._recognition.continuous = false;
          this._recognition.interimResults = false;
          this._recognition.lang = document.documentElement.lang?.startsWith('tr') ? 'tr-TR' : 'en-US';
          this._recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            if (this.input) {
              this.input.value = transcript;
              this.input.dispatchEvent(new Event('input', { bubbles: true }));
            }
            this._voiceSearchActive = false;
            this.voiceSearchBtn?.classList.remove('is-recording');
          };
          this._recognition.onerror = (event) => {
            if (event.error !== 'aborted') {
              console.warn('Sesli arama hatası:', event.error);
            }
            this._voiceSearchActive = false;
            this.voiceSearchBtn?.classList.remove('is-recording');
          };
          this._recognition.onend = () => {
            this._voiceSearchActive = false;
            this.voiceSearchBtn?.classList.remove('is-recording');
          };
        }
        this._voiceSearchActive = true;
        this.voiceSearchBtn?.classList.add('is-recording');
        this._recognition.start();
      }
    
      debounce(fn, delay) {
        var timer = null;
        return function () {
          var context = this,
            args = arguments;
          clearTimeout(timer);
          timer = setTimeout(function () {
            fn.apply(context, args);
          }, delay);
        };
      }

      
      showDefaultCollection() {
        if (!this.defaultCollectionWrapper || this.hasShownDefaultCollection) return;
        
        this.hasShownDefaultCollection = true;
        
        // Suggestions'ı gizle
        if (this.suggestionsContent) {
          this.suggestionsContent.classList.add('hidden');
        }
        
        // Drawer'a has-results class'ını ekle
        if (this.drawerBase) {
          this.drawerBase.classList.add('has-results');
        }
        
        // İlk arama ise wrapper'ı animasyonla aç
        if (this.isFirstSearch && this.defaultCollectionWrapper) {
          this.defaultCollectionWrapper.classList.remove('hidden');
          // Wrapper görünür olduktan sonra collection tabs'ı başlat
          setTimeout(() => {
            if (this.defaultCollectionWrapper) {
              this.defaultCollectionWrapper.classList.add('no-animation');
              // Collection tabs'ı başlat
              this.initCollectionTabs();
            }
          }, 100);
          this.isFirstSearch = false;
        } else if (!this.isFirstSearch && this.defaultCollectionWrapper) {
          this.defaultCollectionWrapper.classList.remove('hidden');
          // Wrapper görünür olduktan sonra collection tabs'ı başlat
          setTimeout(() => {
            this.initCollectionTabs();
          }, 100);
        }
      }

      onChange() { 
     this.searchTerm = this.input.value.trim();
    if (this.searchTerm == '') {
       // Arama temizlendiğinde wrapper'ı gizle ve drawer yüksekliğini sıfırla
       if (this.resultsWrapper) {
         this.resultsWrapper.classList.add('hidden');
       }
       // Default koleksiyonu tekrar göster, divider'ı gizle (sadece "sonuç yok" durumunda gösteriyoruz)
       if (this.noResultsDivider) {
         this.noResultsDivider.classList.add('hidden');
       }
       if (this.defaultCollectionWrapper && this.hasShownDefaultCollection) {
         this.defaultCollectionWrapper.classList.remove('hidden');
         if (this.drawerBase) {
           this.drawerBase.classList.add('has-results');
         }
         // Collection tabs'ı yeniden başlat
         setTimeout(() => {
           this.initCollectionTabs();
         }, 100);
       } else if (this.drawerBase) {
         this.drawerBase.classList.remove('has-results');
       }
       if (this.resultsContainer) {
              this.resultsContainer.classList.add('hidden');
             this.resultsContainer.innerHTML = '';
            }
            if (this.loadingContainer) {
              this.loadingContainer.classList.add('hidden');
            }
     if(this.suggestionsContent){
       this.suggestionsContent.classList.add('hidden'); // Default koleksiyon gösterilirken suggestions gizli
    }
      
    } else {
       // Arama yapılırken default koleksiyonu ve divider'ı gizle
       if (this.defaultCollectionWrapper) {
         this.defaultCollectionWrapper.classList.add('hidden');
       }
       if (this.noResultsDivider) {
         this.noResultsDivider.classList.add('hidden');
       }
     if(this.suggestionsContent){
     this.suggestionsContent.classList.add('hidden');
    }
    
    // Loading gösterilirken eski sonuçları gizle
    if (this.resultsContainer) {
      this.resultsContainer.classList.add('hidden');
    }
    if (this.resultsWrapper) {
      this.resultsWrapper.classList.add('hidden');
    }
    
    // Loading gösterilirken drawer yüksekliğini koru (has-results class'ını ekle)
    if (this.drawerBase) {
      this.drawerBase.classList.add('has-results');
    }
    
    // Loading'i göster (wrapper dışında olduğu için her zaman görünür)
    if(this.loadingContainer){
      this.loadingContainer.classList.remove('hidden');
    }
      this.getSearchResults();
    }
  }

    
      initCollectionTabs() {
        this.collectionTabsWrapper = this.querySelector('[data-collection-tabs-wrapper]');
        this.collectionTabs = this.querySelectorAll('[data-collection-tab]');
        this.collectionProducts = this.querySelectorAll('[data-collection-products]');

        if (!this.collectionTabs || this.collectionTabs.length === 0) {
          if (this.collectionTabsWrapper) {
            this.collectionTabsWrapper.style.display = 'none';
          }
          return;
        }

        if (this.collectionTabs.length === 1) {
          if (this.collectionTabsWrapper) {
            this.collectionTabsWrapper.style.display = 'none';
          }
          this.collectionProducts.forEach((panel, index) => {
            panel.classList.toggle('is-active', index === 0);
          });
          return;
        }

        if (this.collectionTabsWrapper) {
          this.collectionTabsWrapper.style.display = 'flex';
        }

        this.collectionTabs.forEach((tab, index) => {
          tab.onmouseenter = () => {
            if (window.innerWidth > 991) {
              this.activateCollectionByIndex(index, true);
            }
          };
          tab.onclick = (event) => {
            event.preventDefault();
            const url = tab.getAttribute('data-collection-url');
            if (url) {
              window.location.href = url;
            }
          };
        });

        this.activateCollectionByIndex(0, false);

        if (!this.resizeHandler) {
          this.resizeHandler = () => {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => {
              this.initCollectionTabs();
            }, 250);
          };
          window.addEventListener('resize', this.resizeHandler);
        }
      }

      initSearchViewAllButtons() {
        if (this._searchViewAllDelegationBound) return;
        this._searchViewAllDelegationBound = true;
        this.addEventListener('click', (e) => {
          const link = e.target.closest('[data-search-view-all]');
          if (!link) return;
          e.preventDefault();
          const q = this.input ? this.input.value.trim() : '';
          const baseUrl = link.getAttribute('href') || '/search';
          const separator = baseUrl.includes('?') ? '&' : '?';
          window.location = q ? `${baseUrl}${separator}q=${encodeURIComponent(q)}` : baseUrl;
        });
      }

  activateCollectionByIndex(index, scrollToTab = true) {
        this.collectionTabs = this.querySelectorAll('[data-collection-tab]');
        this.collectionProducts = this.querySelectorAll('[data-collection-products]');

        if (!this.collectionTabs.length || !this.collectionProducts.length) return;
        if (index < 0 || index >= this.collectionTabs.length) return;
        if (index >= this.collectionProducts.length) return;

        const activeTab = this.collectionTabs[index];
        const activeProducts = this.collectionProducts[index];
        this.switchCollection(activeTab, activeProducts, scrollToTab);
      }
      
  switchCollection(activeTab, activeProducts, scrollToTab = true) {
        if (!activeTab || !activeProducts) return;

        const allTabs = this.querySelectorAll('[data-collection-tab]');
        const allProducts = this.querySelectorAll('[data-collection-products]');

        allTabs.forEach((tab) => tab.classList.remove('is-active'));
        allProducts.forEach((panel) => panel.classList.remove('is-active'));

        activeTab.classList.add('is-active');
        activeProducts.classList.add('is-active');

        // Seçili tab'ın URL'ini "Tümünü gör" butonuna ata
        const seeAllLink = this.querySelector('.collection-tabs-seeall');
        const collectionUrl = activeTab.getAttribute('data-collection-url');
        if (seeAllLink && collectionUrl) {
          seeAllLink.href = collectionUrl;
        }

        if (scrollToTab && this.collectionTabsWrapper) {
          const tabsScroll = this.collectionTabsWrapper.querySelector('[data-collection-tabs-scroll]');
          if (tabsScroll) {
            const scrollTo = activeTab.offsetLeft - (tabsScroll.clientWidth / 2) + (activeTab.offsetWidth / 2);
            tabsScroll.scrollTo({
              left: Math.max(0, scrollTo),
              behavior: 'smooth'
            });
          }
        }
      }

      getSearchResults() {
        if (!this.resultsContainer) {
          console.error('Results container not found');
          return;
        }
        
        const queryKey = this.searchTerm.replace(' ', '-').toLowerCase();
        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.searchTerm)}&section_id=predictive-search&resources[limit_scope]=each&resources[limit]=7&resources[type]=product`)
          .then((response) => {
            if (!response.ok) {
              console.log('error');
              return;
            }
            return response.text();
          })
          .then((text) => {
            if (!text) return;
            
            const parsedDoc = new DOMParser().parseFromString(text, 'text/html');
            const resultWrapper = parsedDoc.querySelector('[data-result-wrapper]');
            
            if (resultWrapper && this.resultsContainer) {
              // Drawer'a has-results class'ını ekle (yükseklik için)
              if (this.drawerBase) {
                this.drawerBase.classList.add('has-results');
              }

              const hasNoResults = resultWrapper.querySelector('.predictive-search__no-results');

              if (hasNoResults && this.defaultCollectionWrapper) {
                // Sonuç bulunamadığında varsayılan koleksiyon alanını da göster, divider'ı göster
                this.defaultCollectionWrapper.classList.remove('hidden');
                if (this.noResultsDivider) this.noResultsDivider.classList.remove('hidden');
                setTimeout(() => {
                  this.initCollectionTabs();
                }, 100);
              } else if (this.noResultsDivider) {
                this.noResultsDivider.classList.add('hidden');
              }

              // İlk arama ise wrapper'ı animasyonla aç
              if (this.isFirstSearch && this.resultsWrapper) {
                this.resultsWrapper.classList.remove('hidden');
                // Animasyon tamamlandıktan sonra no-animation class'ını ekle
                setTimeout(() => {
                  if (this.resultsWrapper) {
                    this.resultsWrapper.classList.add('no-animation');
                  }
                }, 400); // Transition süresi kadar bekle
                this.isFirstSearch = false; // Flag'i güncelle
              } else if (!this.isFirstSearch && this.resultsWrapper) {
                // Sonraki aramalarda animasyon olmadan göster
                this.resultsWrapper.classList.remove('hidden');
              }

              this.resultsContainer.innerHTML = resultWrapper.innerHTML;
              this.resultsContainer.classList.remove('hidden');
            } else {
              console.warn('Result wrapper not found in response');
              if (this.resultsContainer) {
                this.resultsContainer.innerHTML = '';
                this.resultsContainer.classList.add('hidden');
              }
            }
            
            if (this.loadingContainer) {
              this.loadingContainer.classList.add('hidden');
            }
          })
          .catch((error) => {
            if (error?.code === 20) {
              return;
            }
            console.error('Search error:', error);
            if (this.loadingContainer) {
              this.loadingContainer.classList.add('hidden');
            }
            if (this.resultsContainer) {
              this.resultsContainer.classList.add('hidden');
            }
            // Hata durumunda da has-results class'ını koru (overlay tam ekran kalsın)
            // Eğer sonuç yoksa ve loading de yoksa kaldır
            if (!this.resultsContainer || this.resultsContainer.classList.contains('hidden')) {
              if (!this.defaultCollectionWrapper || this.defaultCollectionWrapper.classList.contains('hidden')) {
                if (this.drawerBase && (!this.loadingContainer || this.loadingContainer.classList.contains('hidden'))) {
                  this.drawerBase.classList.remove('has-results');
                }
              }
            }
          });
      }

     
    }
customElements.define("search-modal-dialog", searchModalDialog );

class predictiveSearchTab extends HTMLElement{
  constructor() {
    super();
    this.searchDrawerModel = this.closest('#search-drawer-model');
    if(!this.searchDrawerModel) return ;
    this.activeTab = this.searchDrawerModel.querySelector('.predictive-search-tab.is-active');
    this.activeTabContent = this.searchDrawerModel.querySelector('.predictive-search-tab-item.active');
    this.tabs = this.querySelectorAll('.predictive-search-tab');
    Array.from(this.tabs).forEach(function(tab){
      if(tab.classList.contains('is-active')) return false;
      tab.addEventListener("click",function(event){
        event.preventDefault();
        this.tabContent = this.searchDrawerModel.querySelector(tab.dataset.tab);
        if(this.tabContent){
          this.closeExisting();
          tab.classList.add('is-active');
          this.tabContent.classList.add('is-active');
          this.tabContent.style.display = 'block';
          this.activeTab = tab;
          this.activeTabContent = this.tabContent;
        }
      }.bind(this))
    }.bind(this))
    if(this.tabs.length > 0){
      this.tabs[0].click();
    }
  }
  closeExisting(){
    if(this.activeTab){
      this.activeTab.classList.remove('is-active')
    }
    if(this.activeTabContent){
      this.activeTabContent.classList.remove('is-active');
      this.activeTabContent.style.display = 'none';
    }
  }
}

customElements.define("predictive-search-tab", predictiveSearchTab);

